export default __webpack_public_path__ + "static/media/Bracers of the Lector.21392b52.jpg";